<!--
 * @Author: xiaokun
 * @Date: 2020-04-12 22:31:29
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-04 14:40:34
 * @Description: 试卷摘要信息
 -->
<template>
  <div class="paper-info">
    <div class="paper-info-left">
      <div class="mb-10 flex-align">
        <div class="paper-title">
          考试名称：
        </div>
        <div>
          <span class="common-content">{{ paperInfo.name }}</span>
        </div>
      </div>
      <div class="mb-10 flex-align">
        <div class="paper-title">
          总题数：
        </div>
        <span class="common-content">{{ paperInfo.questionNum }}</span>
      </div>
      <div class="flex-align">
        <div class="paper-title">
          总分数：
        </div>
        <div>
          <span class="common-content">{{ paperInfo.score }}</span>
        </div>
      </div>
    </div>
    <div class="paper-info-right">
      <div class="mb-10 flex-align">
        <div class="paper-title  paper-tag-title">
          考试标签：
        </div>
        <div>
          <span
            v-for="(item,index) in showTags"
            :key="index"
            class="tag-item"
          >
            {{ item.name }}
          </span>
        </div>
      </div>
      <div class="flex-align">
        <div class="paper-title">
          考试说明：
        </div>
        <span class="common-content paper-desc">{{ paperInfo.description }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PaperInfo',
  components: {},
  props: {
    // paperId
    paperId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      paperInfo: {},
      showTags: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      let _id = this.$route.query.paperId || this.paperId
      let params = {
        _id: _id
      }
      // 如果存在任务id 则表示需要请求该id下的 审批数
      if (this.$route.query.taskId) {
        params.taskId = this.$route.query.taskId
      }
      let res = await MBASVCAPIS.PaperApi.paperSummaryGet(params)
      if (res.success) {
        this.showTags = res.data.showTags
        this.paperInfo = res.data.paperInfo
        // 提交已审未审数到父级展示
        this.$emit('getPeopleNum', res.data.notApprovalNum, res.data.approvalNum)
      } else {
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.paper-info {
  background-color: #fafafa;
  border-radius: 4px;
  border: 1px solid rgba(232, 232, 232, 1);
  padding: 15px 20px;
  font-size: 13px;
  display: flex;
  align-items: flex-start;
  color: #595959;

  .common-content {
    font-weight: 500;
    color: #262626;
    word-break: break-all;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .flex-align {
    display: flex;
    align-items: flex-start;
  }

  .paper-title {
    flex-shrink: 0;
  }

  .paper-tag-title {
    margin-top: 4px;
  }

  .paper-info-left {
    width: 370px;
  }

  .paper-info-right {
    .tag-item {
      color: #6b7b88;
      display: inline-block;
      word-break: keep-all;
      background-color: #ebeff4;
      font-size: 12px;
      margin: 0 8px 8px 0;
      padding: 4px 8px;
      border-radius: 2px;
    }

    .paper-desc {
      width: 497px;
    }
  }
}
</style>
